// Six view tabs, react-router-linked so deep URLs are shareable.
// View slug lives in /tools/production-schedule/:view (defaults to
// /board when the bare path is hit — handled in the parent shell).
import { Link } from "react-router";

export type ProductionView =
  | "board"
  | "gantt"
  | "bays"
  | "cutting"
  | "list"
  | "resource"
  | "analytics";

const TABS: { id: ProductionView; label: string }[] = [
  { id: "board", label: "Spool Board" },
  { id: "gantt", label: "Gantt" },
  { id: "bays", label: "Welding Bays" },
  { id: "cutting", label: "Cutting" },
  { id: "list", label: "Spool List" },
  { id: "resource", label: "Resource Management" },
  { id: "analytics", label: "Analytics" },
];

interface Props {
  active: ProductionView;
  search: string;
}

export function ViewTabs({ active, search }: Props) {
  const querySuffix = search ? `?${search}` : "";
  return (
    <div className="view-bar">
      {TABS.map((t) => (
        <Link
          key={t.id}
          to={`/tools/production-schedule/${t.id}${querySuffix}`}
          className={`view-tab ${t.id === active ? "active" : ""}`}
        >
          {t.label}
        </Link>
      ))}
    </div>
  );
}
